import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

export default function  TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      className="tabpanelVartical"
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-r${index}`}
      aria-labelledby={`vertical-tab-r${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
